import styled, { css } from "styled-components";

import Loader from "components/Layout/Loader";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin-right: 6px;
  &:not(:last-child) {
    margin-bottom: 12px;
  }

  min-height: 54px;

  padding: 6px;

  border-radius: 8px;
  border: 2px solid transparent;
  background-color: ${COLORS.BACKGROUND};

  ${({ checked }: { checked?: boolean }) =>
    checked &&
    css`
      border: 2px solid ${COLORS.CYAN};
      background-color: ${COLORS.BACKGROUND};
    `}

  ${({ isDisabled }: { isDisabled?: boolean }) =>
    isDisabled &&
    css`
      opacity: 0.5;
    `}
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
`;

export const Image = styled.div`
  min-width: 60px;
  min-height: 60px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;

  border-radius: 8px;
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin: 0 10px;
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;

export const ControlWrapper = styled.div`
  display: flex;
  align-items: center;

  flex-shrink: 0;
`;

export const PublishStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  margin-right: 22px;
`;

export const PublishStatusWrapper = styled.div``;
